import { Suspense, useEffect } from "react";
import Loading from "../components/Loading";
import { matchPath, Navigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getCurrentUserAsync } from "../store/auth/auth.thunk";
import { element } from "./routes";

const PageWrapper = ({ route }) => {
  const { element } = route;
  const Component = element;
  return (
    <Suspense
      fallback={
        <Loading
          className={"h-[90vh] w-full flex justify-cener items-center"}
        />
      }
    >
      <Component />
    </Suspense>
  );
};
export default PageWrapper;

const getRouteObject = (wanted) => {
  const allRoutes = [...element];
  const routeObj = allRoutes.find((route) => {
    const match = matchPath(wanted, route.path);
    if (match) return route;
    return null;
  });
  let doc;
  const nestedCheck = [...allRoutes].map((route) => {
    return route.children.find((nestedRoute) => {
      const deepMatch = matchPath(wanted, route.path + nestedRoute.path);
      if (deepMatch) {
        doc = {
          role: route.role,
          ...nestedRoute,
        };
        return;
      }
    });
  });

  const obj = doc ? doc : routeObj ? routeObj : null;
  return obj;
};

export const AuthWrapper = ({ children }) => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const routeObject = getRouteObject(pathname);
  const user = JSON.parse(localStorage.getItem("userInfo"));
  console.log(user);
  useEffect(() => {
    dispatch(getCurrentUserAsync());
  }, [user]);
  console.log("hoya", routeObject);
  if (user === null || !user) {
    return <Navigate to={"/login"} replace={true} />;
  }
  if (user && user.role !== routeObject.role) {
    return <Navigate to={"/login"} replace={true} />;
  }
  return children({ routeObject: routeObject });
};
